function setupSubscribePopup() {
  const subscribePopup = document.querySelector('.subscribe-popup');

  if (!subscribePopup) {
    return;
  }

  if(themeVars.subscribePopupBehaviour === 'show_always' || !getCookie("closed_subscribe_form")) {
    setTimeout(() => {
      subscribePopup.classList.toggle('open');
      document.body.classList.toggle('popup-open');
    }, parseInt(themeVars.subscribePopupDelay) * 1000);
  }

  document.addEventListener('click', function(e) {
    if(e.target.classList.contains('subscribe-popup__close')) {
      subscribePopup.classList.toggle('open');
      document.body.classList.toggle('popup-open');
      
      if(themeVars.subscribePopupBehaviour === 'show_once') {
        setCookie("closed_subscribe_form", "true", 1);
      }
    }
  })

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for(let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
  }
}

export default setupSubscribePopup;